import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Aperture, ArrowUpRight } from "lucide-react";
import { setIntent } from "../lib/nav";

// A quiet, mature note about an emerging capability. Placed at the tail of the
// services page. Intentionally understated: no hero, no popup, no announcement.
const InteractiveExperiences = () => (
    <section
        id="interactive-experiences"
        className="relative py-14 lg:py-20"
        data-testid="interactive-experiences"
    >
        <div className="max-w-5xl mx-auto px-5 lg:px-10">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="rounded-2xl p-7 lg:p-10"
                style={{
                    background: "linear-gradient(135deg, rgba(212,168,87,0.05), rgba(20,20,26,0.7))",
                    border: "1px solid rgba(212,168,87,0.18)",
                }}
            >
                <div className="flex flex-col sm:flex-row gap-6 sm:gap-8">
                    <div className="w-12 h-12 rounded-xl bg-gold/10 border border-gold/25 flex items-center justify-center shrink-0">
                        <Aperture className="w-5 h-5 text-gold" />
                    </div>

                    <div className="flex-1 max-w-3xl">
                        <div className="font-mono text-[10px] uppercase tracking-widest text-gold/85 mb-2">
                            An emerging capability
                        </div>
                        <h3
                            className="font-display text-2xl lg:text-3xl text-ivory leading-tight"
                            data-testid="ide-heading"
                        >
                            Interactive Digital Experiences
                        </h3>

                        <div className="mt-5 space-y-4 text-ivory/70 leading-relaxed text-sm lg:text-base">
                            <p>
                                IndoBlitz continues to explore thoughtful ways in which technology,
                                creativity and storytelling can come together.
                            </p>
                            <p>
                                Our team is gradually developing internal capabilities in interactive
                                digital experiences, prototyping, testing and user engagement. This
                                work is being approached carefully, with a strong focus on learning,
                                experimentation and responsible development.
                            </p>
                            <p>
                                We remain open to selected conversations with businesses and creative
                                partners interested in exploring confidential and well-defined
                                collaboration opportunities in this evolving space.
                            </p>
                        </div>

                        <Link
                            to="/contact"
                            onClick={() => setIntent("interactive-experiences-collab")}
                            className="btn-ghost mt-8 !py-2.5 text-sm"
                            data-testid="ide-cta"
                        >
                            Discuss a Confidential Collaboration
                            <ArrowUpRight className="w-3.5 h-3.5" />
                        </Link>
                    </div>
                </div>
            </motion.div>
        </div>
    </section>
);

export default InteractiveExperiences;
